export const config = {
  clientApiUrl: null,
  serverApiUrl: null,
}

export const setRuntimeConfig = (newConfig) => {
  if (newConfig.clientApiUrl) {
    config.clientApiUrl = newConfig.clientApiUrl
  }
  if (newConfig.serverApiUrl) {
    config.serverApiUrl = newConfig.serverApiUrl
  }
}
